export const spring = {
  default: {
    stiffness: 420,
    damping: 40,
    mass: 1
  }
} as const;
